import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../api';

// Define the API base URL


// Async action for Get Universities
export const getAllUni = createAsyncThunk(
    'auth/get-all-universities',
    async (params, { rejectWithValue }) => {  // Single parameter 'params'
      try {
        const { page, search } = params;  // Destructure 'page' and 'search' from the object
        // Include 'page' and 'search' in the query parameters
        const response = await apiClient.get('/uni', {
          params: {
            page,
            search // Include search in the request to the backend
          }
        });  
        return response.data; // Assuming backend responds with universities and pagination data
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  

// Initial state
const initialState = {
  status: 'idle',
  universities: [], // Initialize as an empty array
  totalCount:null,
  token: null,
  error: null,
  isLoading: false,
  message: null,
};

// Slice
const universitySlice = createSlice({
  name: 'uni',
  initialState,
  extraReducers: (builder) => {
    // Handle Get all University actions
    builder
    .addCase(getAllUni.pending, (state) => {
      state.status = 'loading';
    })
    .addCase(getAllUni.fulfilled, (state, action) => {   
      state.status = 'succeeded';
      state.universities = action.payload.universities; // Store the array of universities from the payload
      state.totalCount = action.payload.totalCount;
    })
    .addCase(getAllUni.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.payload; // Capture the error from backend
    });
  },
});


export default universitySlice.reducer;
